export const COLUMN_CLIENT_NAME = 'CLIENT_NAME';
export const COLUMN_CAMPAIGN_NAME = 'CAMPAIGN_NAME';
export const COLUMN_DATE = 'DATE';
export const COLUMN_CLICKS = 'CLICKS';
export const COLUMN_IMPRESSIONS = 'IMPRESSIONS';
export const COLUMN_PURCHASE_VALUE = 'PURCHASE_VALUE';
export const COLUMN_COST = 'COST';
export const COLUMN_CONVERSIONS = 'CONVERSIONS';
// El backend puede nombrar esta columna en un error aunque el wizard todavía no la mapee: existe
// para que tenga nombre propio en un mensaje, NO para agregar una fila al paso 3.
export const COLUMN_ADGROUP_NAME = 'ADGROUP_NAME';

export const COLUMNS = [COLUMN_DATE, COLUMN_CAMPAIGN_NAME, COLUMN_COST, COLUMN_CLICKS, COLUMN_IMPRESSIONS, COLUMN_PURCHASE_VALUE, COLUMN_CONVERSIONS, COLUMN_CLIENT_NAME];

// Catálogo de nombres legibles. NO se accede directo: se lee con `resolveColumnLabel` de
// `sheetIssues.js`, que además pasa por i18n y cae a la clave cruda si no la conoce.
export const DATA_BY_COLUMN = {
    [COLUMN_CLIENT_NAME]: {Spanish:"Cliente"},
    [COLUMN_ADGROUP_NAME]: {Spanish:"Grupo de anuncios"},
    [COLUMN_CAMPAIGN_NAME]: {Spanish:"Campaña"},
    [COLUMN_DATE]: {Spanish:"Fecha"},
    [COLUMN_CLICKS]: {Spanish:"Clicks"},
    [COLUMN_IMPRESSIONS]: {Spanish:"Impresiones"},
    [COLUMN_PURCHASE_VALUE]: {Spanish:"Valor de Compra"},
    [COLUMN_COST]: {Spanish:"Costo"},
    [COLUMN_CONVERSIONS]: {Spanish:"Conversiones"},
};

export const MANDATORY_COLUMNS = [COLUMN_CAMPAIGN_NAME, COLUMN_DATE, COLUMN_COST];
